import {ReactElement, ReactNode} from "react";

export interface IconLabelProps {
    icon: ReactNode
    children: ReactNode
}

export function IconLabel(props: IconLabelProps): ReactElement {
    return (
        <div className="flex items-center gap-1">
            <span>{props.icon}</span>
            <span>{props.children}</span>
        </div>
    );
}